import axios from "axios";

const getClientObject = async function getClientObject(id) {
  const url = "go/init?id=" + id;
  const { data } = await axios.get(url);
  return data;
};

export default getClientObject;
